"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIActions = exports.Overlay = exports.clearSelectedPiece = exports.closeOverlay = exports.openOverlay = exports.uiReducer = void 0;
var reducer_1 = require("./reducer");
Object.defineProperty(exports, "uiReducer", { enumerable: true, get: function () { return reducer_1.reducer; } });
var actions_1 = require("./actions");
Object.defineProperty(exports, "openOverlay", { enumerable: true, get: function () { return actions_1.openOverlay; } });
Object.defineProperty(exports, "closeOverlay", { enumerable: true, get: function () { return actions_1.closeOverlay; } });
Object.defineProperty(exports, "clearSelectedPiece", { enumerable: true, get: function () { return actions_1.clearSelectedPiece; } });
var overlay_1 = require("./overlay");
Object.defineProperty(exports, "Overlay", { enumerable: true, get: function () { return overlay_1.Overlay; } });
exports.UIActions = __importStar(require("./actions"));
